import $ from "jquery";
import navigation from "./navigation";
import trackController from "../track/controller/trackController";
import analyticsModal from "../track/models/analyticsModel";

const {getCookie} = require("../common");

(function () {

  $(document).ready(function () {

    if (document.querySelector(".emailView")) {
      const collect = document.getElementsByClassName('emailView'),
        collectBlocks = Array.prototype.slice.call(collect),
        installView = document.getElementsByClassName('installView'),
        installViewBlocks = Array.prototype.slice.call(installView),
        viewStatus = localStorage.getItem('emailCollect') || getCookie('h'),
        redirectLink = document.querySelector(".tryAmzIdLink"),
        software = redirectLink.dataset.collectSoftware;

      const changeTitleHandler = {

        init: function () {
          const targets = document.querySelectorAll('[data-b-title]'),
            placeHolders = document.querySelectorAll('[data-b-place]'),
            links = document.querySelectorAll('[data-b-link]'),
            classNames = document.querySelectorAll('[data-b-class]');

          if (targets.length > 0 && targets[0].dataset.bTitle) {
            this.change(targets, 'text');
            this.listener(targets, 'text');
          }

          if (placeHolders.length > 0 && placeHolders[0].dataset.bPlace) {
            this.change(placeHolders, 'placeholder');
            this.listener(placeHolders, 'placeholder');
          }

          if (links.length > 0 && links[0].dataset.bLink) {
            this.change(links, 'link');
            this.listener(links, 'link');
          }

          if (classNames.length > 0 && classNames[0].dataset.bClass) {
            this.change(classNames, 'class');
            this.listener(classNames, 'class');
          }
        },
        change: function (targets, type) {
          targets.forEach(e => {
            const width = window.innerWidth;

            switch (type) {
              case 'text':
                if (width < 768) {
                  e.innerHTML = e.dataset.sTitle;
                } else if (width >= 768 && width <= 991) {
                  e.innerHTML = e.dataset.tabTitle || e.dataset.bTitle;
                } else {
                  e.innerHTML = e.dataset.bTitle;
                }
                break;
              case 'placeholder':
                if (width < 768) {
                  e.placeholder = e.dataset.sPlace
                } else if (width >= 768 && width <= 991) {
                  e.placeholder = e.dataset.tabPlace || e.dataset.bPlace;
                } else {
                  e.placeholder = e.dataset.bPlace;
                }
                break;
              case 'link':
                if (width < 768) {
                  e.href = e.dataset.sLink
                } else if (width >= 768 && width <= 991) {
                  e.href = e.dataset.tabLink || e.dataset.bLink;
                } else {
                  e.href = e.dataset.bLink;
                }
                break;
              case 'class':
                if (width < 768) {
                  e.classList.add(e.dataset.sClass);
                  e.classList.remove((e.dataset.tabClass || e.dataset.bClass), e.dataset.bClass);
                } else if (width >= 768 && width <= 991) {
                  e.classList.add(e.dataset.tabClass || e.dataset.bClass);
                  e.classList.remove(e.dataset.sClass);
                } else {
                  e.classList.add(e.dataset.bClass);
                  e.classList.remove(e.dataset.sClass);
                }
                break;
              default:
                break;
            }
          });
        },
        listener: function (targets, status) {
          window.addEventListener("resize", () => {
            this.change(targets, status);
          });
        }
      }

      changeTitleHandler.init();

      const tongleView = (targets, status) => {
        targets.forEach(t => {
          t.style.display = status ? "block" : "none";
        });
      }

      if (viewStatus) {
        tongleView(installViewBlocks, true);
      } else {
        tongleView(collectBlocks, true);

        const sendEmailRequest = (email, type, inp, btn) => {
          const isOption = isNaN(+type) || typeof type === "string"
          const body = {
            [isOption ? "option" : "type"]: type,
            "email": localStorage.getItem('errorEmail') || email
          }
          trackController(body)
            .then(function (response) {
              if (response.ok) {
                localStorage.setItem('emailCollect', 'true');
                localStorage.setItem('collectData', email);
                tongleView(collectBlocks, false);
                tongleView(installViewBlocks, true);
                inp.value = "";
                redirectLink.click();
                navigation.updateAuthUrls();
                acceptEmail(inp);
              }
            })
            .catch(err => {
              toggleBtn(btn);
              declineEmail(inp, err.message, "Something went wrong. Please try again.");
            });
        }

        const declineEmail = (inp, err, placeHolderText) => {
          analyticsModal(false, software, err);
          inp.classList.add('emailAlert');
          inp.placeholder = placeHolderText;
          inp.value = "";
        }

        const acceptEmail = (inp) => {
          inp.classList.remove('emailAlert');
          inp.placeholder = "example@amzscout.net";
          analyticsModal(true, software);
        }

        const toggleBtn = (target) => {
          target.classList.toggle("disabled");
        }

        const emailHandler = (e) => {
          const target = e.target;
          const inp = target.previousElementSibling;
          if (target.tagName === 'BUTTON') {
            if (inp.value.length > 0 && emailIsValid(inp.value)) {
              toggleBtn(target);
              sendEmailRequest(inp.value, inp.dataset.type ? parseInt(inp.dataset.type) : 'proforfreeelementfooter', inp, target);
            } else {
              const isFullInp = inp.value.length > 0;
              declineEmail(inp, isFullInp ? "Email Validation Failed" : "Empty Input", !isFullInp ? "Please enter your email" : "Your email address is invalid");
            }
          }
        }

        collectBlocks.forEach(element => {
          element.addEventListener('click', e => {
            emailHandler(e);
          });
        });
      }
    }

  });

}());
